const dns_retrieve_domain_records_dialog = {
	description:
		"Geben Sie hier den Domainnamen ein, dessen vorhandene DNS-Einträge Sie abrufen möchten. Einige Einträge können hier fehlen.",

	domain_search_input: {
		label: "Domainname",
		placeholder: "z.B. 'codebee.de'",
	},
	message: {
		success: "Die DNS-Einträge wurden erfolgreich hinzugefügt.",
	},
	search_button: {
		label: "Aufzeichnungen abrufen",
	},
	submit_button: {
		label: "Hinzufügen ({{record_selected_count}} Datensätze)",
	},
	title: "DNS-Abfrage externe Domain",
};

export default dns_retrieve_domain_records_dialog;
